import request from '@/utils/request'

const processApi = {
  addOrUpdateHelpPersonForPage: '/auth/online/addOrUpdateHelpPersonForPage', // 新增帮扶对象
  delHelpPersonForPage: '/auth/online/delHelpPersonForPage', // 删除帮扶对象
  needHelpPersonForPage: '/auth/online/needHelpPersonForPage', // 查询帮扶对象
  updateStatus: '/auth/online/updateStatus' // 帮扶对象启用/禁用
}

export function addOrUpdateHelpPersonForPage(parameter) {
  return request({
    url: processApi.addOrUpdateHelpPersonForPage,
    method: 'post',
    data: parameter
  })
}

export function delHelpPersonForPage(parameter) {
  return request({
    url: processApi.delHelpPersonForPage,
    method: 'post',
    data: parameter
  })
}

export function updateStatus(parameter) {
  return request({
    url: processApi.updateStatus,
    method: 'post',
    data: parameter
  })
}

export function needHelpPersonForPage(parameter) {
  return request({
    url: processApi.needHelpPersonForPage,
    method: 'post',
    data: parameter
  })
}
